import React from 'react'
import styles from './Register.module.scss';
import formStyles from '../../components/common/ui/Form.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';

const useValid = () => {
  const [value, setValue] = useState(null);
  const [isChecked, setChecked] = useState(false);
  const [isFetching, setFetching] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState(null);

  const validate = (url) => {
    setChecked(false);
    setFetching(true);

    axios.get(url)
      .then((res) => {
        setIsValid(res.data.isValid);
      })
      .catch((err) => {
        setError(err);
        alert('오류가 발생하였습니다.');
      })
      .finally(() => {
        setChecked(true);
        setFetching(false);
      })
  }

  const resetValidation = () => {
    setChecked(false);
    setFetching(false);
    setIsValid(false);
  }

  return [{
    value: value,
    isChecked: isChecked,
    isFetching: isFetching,
    error: error,
    isValid: isValid
  }, setValue, validate, resetValidation];
}

const Register = () => {

  const [email, setEmail, valEmail, resetValEmail] = useValid();
  const [nickname, setNickname, valNickname, resetValNickname] = useValid();
  const [isNicknameLengthValid, setNicknameLengthValid] = useState(false);

  const [password, setPassword] = useState();
  const [passwordCheck, setPasswordCheck] = useState();

  const [isPasswordValid, setPasswordValid] = useState(false);
  const [isPasswordLengthValid, setPasswordLengthValid] = useState(false);

  const [isRegistering, setRegistering] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const name = e.target.name;
    if (name === 'email') {
      setEmail(e.target.value);
      resetValEmail();
    }
    else if (name === 'password') {
      const value = e.target.value;
      const length = value ? value.length : 0;

      setPassword(value);
      setPasswordValid(value === passwordCheck);
      setPasswordLengthValid((length >= 8 && length <= 16));
    }
    else if (name === 'passwordCheck') {
      const value = e.target.value;
      setPasswordCheck(value);
      setPasswordValid(password === value);
    }
    else if (name === 'nickname') {
      const value = e.target.value;
      const length = value ? value.length : 0;

      setNickname(e.target.value);
      resetValNickname();
      setNicknameLengthValid((length >= 1 && length <= 20));
    }
  }

  const validateEmail = () => {
    if (!email.value){
      alert('내용을 입력해주세요.');
      return;
    }

    valEmail(`/api/profile/validateEmail?email=${email.value}`);
  }

  const validateNickname = () => {
    if (!nickname.value){
      alert('내용을 입력해주세요.');
      return;
    }

    valNickname(`/api/profile/validateNickname?nickname=${nickname.value}`);
  }

  const validateForm = () => {
    
    if (!email.isChecked){
      alert('이메일 중복 확인을 해주세요.');
      return false;
    }

    if (!email.isValid){
      alert('이메일이 유효하지 않습니다.');
      return false;
    }

    if (!isPasswordValid || !isPasswordLengthValid){
      alert('비밀번호를 확인해주세요.');
      return false;
    }

    if (!nickname.isChecked){
      alert('닉네임 중복 확인을 해주세요.');
      return false;
    }

    if (!isNicknameLengthValid || !nickname.isValid){
      alert('닉네임을 확인해주세요.');
      return false;
    }

    return true;
  }

  const register = (e) => {
    e.preventDefault();

    if (isRegistering){
      return;
    }

    if (!validateForm()){
      return;
    }

    setRegistering(true);
    axios.post('/api/profile/register', {
      email:email.value,
      password:password,
      nickname:nickname.value
    }).then((res) => {
      alert('회원가입이 완료되었습니다. 로그인 페이지로 이동합니다.');
      navigate('/login');
    })
    .catch((err) => {
      alert('오류가 발생하였습니다.');
    })
    .finally(()=>{
      setRegistering(false);
    });
  }

  return (
    <div id={styles.wrapper_register}>
      <div id={styles.wrapper_body}>
        <div className={styles.content}>
          <div className={styles.title}>
            <p style={{ fontFamily: 'ScDream', fontSize: '30px', cursor:'pointer' }} onClick={()=>{navigate('/')}}>무재달닷컴</p>
            <p style={{ fontSize: '17px', marginBottom: '10px' }}>회원가입</p>
          </div>
          <form onSubmit={register}>
            <div className={styles.container_input}>
              <input className={formStyles.input} required style={{ width: '470px' }} type='email' placeholder='이메일' name='email' value={email.value || ''} onChange={handleChange}></input>
              {(email.isChecked && email.isValid) ?
                <div className={styles.img_check}/> : 
                <button className={formStyles.button} type='button' style={{
                  width: '100px',
                  position: 'absolute',
                  right: '0'
                }} onClick={validateEmail}><p>중복확인</p></button>
              }
            </div>
            {(email.isChecked && !email.isValid) && <p className={styles.error}>이미 사용중인 이메일입니다.</p>}

            <input className={formStyles.input} required type='password' placeholder='비밀번호' name='password' value={password || ''} onChange={handleChange}></input>
            {(password && !isPasswordLengthValid) && <p className={styles.error}>비밀번호는 8~16자리만 가능합니다.</p>}
            <input className={formStyles.input} required type='password' placeholder='비밀번호 확인' name='passwordCheck' value={passwordCheck || ''} onChange={handleChange}></input>
            {(!isPasswordValid && password) && <p className={styles.error}>비밀번호가 일치하지 않습니다.</p>}
            
            <div className={styles.container_input}>
              <input className={formStyles.input} required style={{ width: '470px' }} type='text' placeholder='닉네임' name='nickname' value={nickname.value || ''} onChange={handleChange}></input>
              {(nickname.isChecked && nickname.isValid) ?
                <div className={styles.img_check}/> : 
                <button className={formStyles.button} type='button' style={{
                  width: '100px',
                  position: 'absolute',
                  right: '0'
                }} onClick={validateNickname}><p>중복확인</p></button>
              }
            </div>
            {(nickname.value && !isNicknameLengthValid) && <p className={styles.error}>닉네임은 20자리 이하만 가능합니다.</p>}
            {(nickname.isChecked && !nickname.isValid) && <p className={styles.error}>이미 사용중인 닉네임입니다.</p>}
            <button className={formStyles.button} style={{ marginTop: '20px' }} type='submit'><p>회원가입</p></button>
          </form>

        </div>
      </div>
    </div>
  )
}

export default Register